import React, { Component, Fragment } from "react";
import utils from "../../../../../utils/utils";

export default class NovoForm extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    totalAno = (serie) => {
        if(serie) return serie.reduce((acc, atual) => acc + atual, 0);
    }

    render() {
        let { unidade, metas, categoria, indicadoresnome, indicadoresid, metasDaUnidade, formDisabled, metasMensais } = this.props;
        metasDaUnidade = metasDaUnidade && (metasDaUnidade.filter(meta => {
            return meta.categoria.toUpperCase() === categoria.toUpperCase() && meta.unidade === unidade;
        })[0]);

        let despesaCategoria;
        try {
            despesaCategoria = metasMensais && metasMensais.filter(cat => cat.categoria === categoria && cat.unidade === unidade)[0].valores.despesa;
        } catch(erro) {

        }

        return (
            <Fragment>
                <table id={this.props.id} className="text-center table-sm">
                    <thead>
                        <tr>
                            <th colSpan="13">{categoria}</th>
                        </tr>
                        <tr>
                            <th>Indicador</th>
                            <th scope="col">Total</th>
                            <th scope="col">Jan</th>
                            <th scope="col">Fev</th>
                            <th scope="col">Mar</th>
                            <th scope="col">Abr</th>
                            <th scope="col">Mai</th>
                            <th scope="col">Jun</th>
                            <th scope="col">Jul</th>
                            <th scope="col">Ago</th>
                            <th scope="col">Set</th>
                            <th scope="col">Out</th>
                            <th scope="col">Nov</th>
                            <th scope="col">Dez</th>
                        </tr>
                    </thead>
                    <tbody>

                    {indicadoresnome.map((mes, key) => {
                            try {
                                if(indicadoresid[key] === "despesa" || indicadoresid[key] === "receita") return;
                                return (
                                    ["receita", "despesa"].includes(indicadoresid[key]) ?
                                        <tr key={key}>
                                            <th scope="row" style={{ textTransform: "capitalize" }} >{indicadoresnome[key]}</th>
                                            <td scope="col">{utils.formataValorMoeda(this.totalAno(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]]))}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][0])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][1])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][2])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][3])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][4])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][5])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][6])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][7])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][8])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][9])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][10])}</td>
                                            <td scope="col">{utils.formataValorMoeda(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][11])}</td>
                                        </tr>
                                    :
                                        <tr key={key}>
                                            <th scope="row">{indicadoresnome[key]}</th>
                                            <td scope="col">{utils.formataValor(this.totalAno(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]]))}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][0])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][1])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][2])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][3])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][4])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][5])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][6])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][7])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][8])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][9])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][10])}</td>
                                            <td scope="col">{utils.formataValor(metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][11])}</td>
                                        </tr>
                                )
                            } catch(erro) {
                            }
                        })}

                        {/* <tr id={categoria}>
                            <th scope="row">Despesa</th>
                            <td scope="col">{despesaCategoria && despesaCategoria.reduce((acc, atual) => acc + atual, 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || "-"}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[0])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[1])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[2])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[3])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[4])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[5])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[6])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[7])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[8])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[9])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[10])}</td>
                            <td scope="col">{utils.formataValorMoeda(despesaCategoria && despesaCategoria[11])}</td>
                        </tr> */}

                    </tbody>
                </table>
                                                
            </Fragment>
        )
    }
}